define("shared/components/shared/ui/ember-drop", ["exports", "@ember/component", "@ember/object", "@ember/runloop", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _runloop, _utils, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/runloop",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="shared-ember-drop"
    ...attributes
    {{did-insert this.initialize}}
    {{did-update this.updateDrop this._drop}}
    {{will-destroy this.destroyDrop}}
  >
    {{yield (hash closeAction=(action "closeAction") openAction=(action "openAction"))}}
  </div>
  */
  {
    "id": "EfKxU5Zu",
    "block": "[[[11,0],[24,0,\"shared-ember-drop\"],[17,1],[4,[38,0],[[30,0,[\"initialize\"]]],null],[4,[38,1],[[30,0,[\"updateDrop\"]],[30,0,[\"_drop\"]]],null],[4,[38,2],[[30,0,[\"destroyDrop\"]]],null],[12],[1,\"\\n  \"],[18,2,[[28,[37,4],null,[[\"closeAction\",\"openAction\"],[[28,[37,5],[[30,0],\"closeAction\"],null],[28,[37,5],[[30,0],\"openAction\"],null]]]]]],[1,\"\\n\"],[13]],[\"&attrs\",\"&default\"],false,[\"did-insert\",\"did-update\",\"will-destroy\",\"yield\",\"hash\",\"action\"]]",
    "moduleName": "shared/components/shared/ui/ember-drop.hbs",
    "isStrictMode": false
  });
  /* global Drop:readable */

  /**
   * Arguments:
   * - beforeClose (function) Function that is run before closing the drop
   * - blurDelay {number} Amount of time (in milliseconds) to delay closing the drop after blur
   * - classes {string} Additional class names to be added to the drop
   * - closeDelay {number} Sets both the hoverCloseDelay and blurDelay
   * - constrainToScrollParent {boolean} Similar to constrainToWindow but for the target element's first scroll parent
   * - constrainToWindow {boolean} Flip the drop when it would otherwise be outside the viewport
   * - content (DOM Element, HTML string, function) The content that should be rendered into the Drop
   * - contentSelector {string} The HTML class attached to the content
   * - focusDelay {number} Amount of time (in milliseconds) to delay opening the drop after focus
   * - hoverCloseDelay {number} Amount of time (in milliseconds) to delay closing the drop after mouseout
   * - hoverOpenDelay {number} Amount of time (in milliseconds) to delay opening the drop after mouseover
   * - onOpen (function) Specifies an action to occur on the 'open' event binding
   * - onClose (function) Specifies an action to occur on the 'close' event binding
   * - openDelay {number} Sets both the hoverOpenDelay and focusDelay
   * - openOn {string} Specifies what event on the target opens the drop
   * - openOnInsert {boolean} Open drop after delay
   * - position {string} Position specifies the attachment point (on the target) to attach the drop to
   * - remove {boolean} Drop element removed from the DOM when the drop is closed and recreated when it's opened
   * - tetherOptions {object} Additional options can be passed to customize Drop even further
   */
  let EmberDropComponent = _exports.default = (_dec = (0, _object.computed)('args.target'), (_class = class EmberDropComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "_drop", _descriptor, this);
    }
    get openOnInsertDelay() {
      return this.args.openOnInsertDelay ?? 100;
    }
    initialize(element) {
      this.addDrop(element);
      this.positionDrop();
      if (this.args.openOnInsert) {
        (0, _runloop.later)(() => this.openDrop(this._drop), this.openOnInsertDelay);
      }
    }
    destroyDrop(element) {
      const {
        _drop
      } = this;
      (0, _runloop.schedule)('render', () => {
        this.removeElement(element);
        this.removeDrop(_drop);
      });
    }
    updateDrop(element) {
      this.removeDrop(this._drop);
      this.addDrop(element);
      this.positionDrop();
    }
    closeAction() {
      this.closeDrop(this._drop);
    }
    openAction() {
      this.openDrop(this._drop);
    }
    positionDrop() {
      if (this._drop) {
        this._drop.position();
      }
    }
    addDrop(element) {
      if (this._dropTarget) {
        this._drop = new Drop(this._dropOptions(element));
        if (this.args.onOpen) {
          this._drop.on('open', () => this.args.onOpen(), this);
        }
        if (this.args.onClose) {
          this._drop.on('close', () => this.args.onClose(), this);
        }
        if (this.args.setCloseAction) {
          this.args.setCloseAction(this.closeDrop, this._drop);
        }
        if (this.args.setOpenAction) {
          this.args.setOpenAction(this.openDrop, this._drop);
        }
      }
    }
    removeDrop(drop) {
      if (drop) {
        drop.destroy();
      }
    }
    openDrop(dropInstance) {
      if (dropInstance) {
        dropInstance.open();
      }
    }
    closeDrop(dropInstance) {
      if (dropInstance) {
        dropInstance.close();
      }
    }
    removeElement(element) {
      if (element.parentNode) {
        element.parentNode.removeChild(element);
      }
    }
    get _dropTarget() {
      let {
        target
      } = this.args;
      if (target && target.element) {
        target = target.element;
      }
      return target;
    }
    _beforeClose() {
      // we don't really listen for "beforeClose" action, and it was causing problems
    }
    _dropOptions(element) {
      const self = this;
      const options = {
        element,
        target: document.querySelector(this._dropTarget),
        beforeClose() {
          self._beforeClose();
        }
      };
      const {
        contentSelector,
        content
      } = this.args;
      if (!(0, _utils.isNone)(contentSelector)) {
        options.content = document.querySelector(contentSelector);
      } else if (!(0, _utils.isNone)(content)) {
        options.content = content;
      }
      if (!options.content && this._drop) {
        options.content = this._drop.options?.content;
      }
      ['blurDelay', 'classes', 'closeDelay', 'constrainToScrollParent', 'constrainToWindow', 'focusDelay', 'hoverCloseDelay', 'hoverOpenDelay', 'openDelay', 'openOn', 'position', 'remove', 'tetherOptions'].forEach(optionName => {
        const optionValue = this.args[optionName];
        if (optionValue !== undefined) {
          options[optionName] = optionValue;
        }
      });
      return options;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_drop", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "initialize", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "destroyDrop", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "destroyDrop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateDrop", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateDrop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeAction", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openAction", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_dropTarget", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "_dropTarget"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, EmberDropComponent);
});